export const BUILD_VERSION = '1775233296';
